import { Trans, useTranslation } from 'next-i18next';
import { BOTTOM_CTA_IMAGE, SECTION_PADDING } from '../constants';
import { BoardLandingCtaButton } from './BoardLandingCtaButton';
export function BoardLandingBottomCta() {
  const {
    t
  } = useTranslation(['boardLanding']);
  return <section aria-labelledby="board-landing-bottom-cta-heading" className={`flex flex-col items-center gap-lg bg-neutral min-[1025px]:gap-2xl ${SECTION_PADDING}`} data-sentry-component="BoardLandingBottomCta" data-sentry-source-file="BoardLandingBottomCta.tsx">
      <img src={BOTTOM_CTA_IMAGE} alt="" width={400} height={140} loading="lazy" className="h-auto w-[400px] max-w-full" />

      {/* 줄바꿈이 로케일별 문구 길이에 달려 있어 `\n` + whitespace-pre-line 으로 둔다. */}
      <h2 id="board-landing-bottom-cta-heading" className="whitespace-pre-line text-center text-heading-xl-extrabold text-default min-[751px]:text-display-sm-extrabold">
        <Trans t={t} i18nKey="boardLanding:bottomCta.title" components={{
        Strong: <strong className="text-strong" />
      }} data-sentry-element="Trans" data-sentry-source-file="BoardLandingBottomCta.tsx" />
      </h2>

      <BoardLandingCtaButton location="bottom" data-sentry-element="BoardLandingCtaButton" data-sentry-source-file="BoardLandingBottomCta.tsx" />
    </section>;
}